import { requiredFieldsByStage } from 'components/Cases/CaseFormStep/CaseFormStep.helper';
import { Action, actionStatus, CaseForm, CaseStatus, caseStatus } from 'queries/cases/types';
import { UseFormGetValues } from 'react-hook-form';

type StatusRuleParams = {
  isCurrentStatus: boolean;
  getValues: UseFormGetValues<CaseForm>;
  currentStatus: CaseStatus;
};
type StatusRules = {
  [key in CaseStatus]: (params: StatusRuleParams) => boolean;
};
const validateActions = (actions: Action[]) => {
  const nonDeletedActions = actions?.filter((action) => !action.deleted) ?? [];

  if (nonDeletedActions.length === 0) return { isValid: true };

  const allActionsValid = nonDeletedActions.every(
    (action) => action.status === actionStatus.executed && action.end_date,
  );

  return { isValid: allActionsValid };
};

const isStageInvalid = (stage: CaseStatus, getValues: UseFormGetValues<CaseForm>): boolean => {
  const requiredFields = requiredFieldsByStage[stage];

  if (!requiredFields || requiredFields.length === 0) return false;
  const stageRequiredValues = getValues(requiredFields);
  return stageRequiredValues.some((value) => value === undefined || value === null || value === '');
};

export const statusRules: StatusRules = {
  [caseStatus.diagnosis]: () => false,

  [caseStatus.actions]: ({ getValues, currentStatus }) => {
    const isDiagnosisInvalid = isStageInvalid(caseStatus.diagnosis, getValues);

    return currentStatus === caseStatus.diagnosis && isDiagnosisInvalid;
  },

  [caseStatus.feedback]: ({ isCurrentStatus, getValues }) => {
    if (isCurrentStatus) return false;
    const isDiagnosisInvalid = isStageInvalid(caseStatus.diagnosis, getValues);
    const actions = getValues('actions') ?? [];
    const { isValid } = validateActions(actions);
    return !isValid || isDiagnosisInvalid;
  },

  [caseStatus.closed]: ({ getValues, currentStatus }) => {
    const isFeedbackInvalid = isStageInvalid(caseStatus.feedback, getValues);
    if (currentStatus === caseStatus.feedback && !isFeedbackInvalid) {
      return false;
    }
    return true;
  },

  [caseStatus.canceled]: () => false,
};
